import React from 'react';
import ActionBar from '../../layout/ActionBar';
import ReportTableViewSwitcher from './ReportTableViewSwitcher';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { usePageTitle } from '../../../util/pageTitle';

export type GroupBy = 'month' | 'week';

export interface ReportListWithSwitcherProps {
  tableViewSwitcher: React.ReactNode;
}

export interface ReportPageWithMonthWeekSwitchProps {
  /** Page title (breadcrumb; "Reports" is appended) */
  title: string;
  /** Component to render when groupBy is 'month' */
  MonthList: React.ComponentType<ReportListWithSwitcherProps>;
  /** Component to render when groupBy is 'week' */
  WeekList: React.ComponentType<ReportListWithSwitcherProps>;
  /** localStorage key for groupBy (default 'report-groupBy') */
  storageKey?: string;
}

/**
 * Report page that switches between a month list and a week list.
 * Renders ActionBar, month/week switcher, and the active list with the switcher in the table toolbar.
 */
function ReportPageWithMonthWeekSwitch({
  title,
  MonthList,
  WeekList,
  storageKey = 'report-groupBy',
}: ReportPageWithMonthWeekSwitchProps) {
  usePageTitle([title, 'Reports']);
  const [groupBy, setGroupBy] = useLocalStorage<GroupBy>(storageKey, 'month');

  const tableViewSwitcher = (
    <ReportTableViewSwitcher groupBy={groupBy} setGroupBy={setGroupBy} />
  );

  return (
    <>
      <ActionBar />
      {groupBy === 'month' ? (
        <MonthList tableViewSwitcher={tableViewSwitcher} />
      ) : (
        <WeekList tableViewSwitcher={tableViewSwitcher} />
      )}
    </>
  );
}

export default ReportPageWithMonthWeekSwitch;
